import React, { useEffect, useState } from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from './Breadcrumb'
import { Icon } from '@iconify/react/dist/iconify.js'

import JobsTable from './JobTable'
import { Link, useParams } from 'react-router-dom'
import CompanyJobTable from './CompanyJobTable'
import { Card, CardBody, Spinner } from 'react-bootstrap'
import { API_URL } from '..'

export default function JobStatusPage() {
    const {status} = useParams();
  const [jobsData , setJobData] = useState([])
  const [active, setActive] = useState(null)
  const [loadingTrue, setloadingTrue] = useState(false)
  const [currentUser , setCurrentUser] = useState({})
  const [currentValues, setValues] = useState({
    accept: 0,
    total: 0,
    declined: 0,
    completed: 0,
  });

  const fetchJobs = async ()=>{
    setloadingTrue(true)
    const user = JSON.parse(localStorage.getItem('user'));
    
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }
       let url= "";
       let jsonBody= JSON.stringify({
        "user_id": user.id,
        "role" : user.role
       });
       let response;
       if(user.role == 'user'){
           response = await fetch(`${API_URL}/api/jobs/${status}`, { 
            method: "POST",
            body:jsonBody,
            headers: headersList
          });
        let data = await response.json();
          setJobData(data)
       }else if(user.role =='owner'){
        let response = await fetch( `${API_URL}/api/jobs/${user.id}`, { 
          method: "GET",
          headers: headersList
        });
        
        let data = await response.json();
      //   console.log(data)
      setloadingTrue(false)
        if(data.length !==0){
          
          if(status === 'total'){
            setJobData(data)
          }else if(status === 'in-progress'){
            const declinedCount = data.filter(
              (item) => item.status === "in-progress"
            )
            setJobData(declinedCount)
          }else if(status === 'declined'){
            const declinedCount = data.filter(
              (item) => item.assigned_to_status === "declined"
            )
            setJobData(declinedCount)
          }else if(status === 'completed'){
            const declinedCount = data.filter(
              (item) => item.status === "completed"
            )
            setJobData(declinedCount)
          }else if(status === 'new'){
            const declinedCount = data.filter(
              (item) => item.status === "new"
            )
            setJobData(declinedCount)
          }
          }
       }
       
       else{
         response = await fetch( `${API_URL}/api/jobs/${status}`, { 
          method: "POST",
          body: jsonBody,
          headers: headersList
        });
        setloadingTrue(false)
        let data = await response.json();
         setJobData(data)
       
       }
       
      
}
const fetchJobsCompany = async ()=>{
  setloadingTrue(true)
  const user = JSON.parse(localStorage.getItem('user'));
  
  let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
     }
     let url= "";
     let jsonBody= JSON.stringify({
      "id": user.id
     });
      let response = await fetch(`${API_URL}/api/job/affiliate/fetch/${user.id}/${status}`, { 
          method: "GET",
          headers: headersList
        });
        
        let data = await response.json();
      //   console.log(data)
      setloadingTrue(false)
      if(response.status === 200){
          setJobData(data.data.reverse())
     
      }
}
useEffect(()=>{
const active = localStorage.getItem('activeTab');
setActive(active)
console.log(active)
if(active == 'main'){
  fetchJobs()
}else{
      fetchJobsCompany()
}
},[1])
  return (
    <>
     <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />

        {/* TableDataLayer */}
        {
            loadingTrue === true ? 
            <div className='row'>
              <div className='col-md-12 text-center'>
              <Spinner style={{color:'blue' ,fontWeight: '400'}} color={'blue'} />
              </div>
            </div>
            : null
          }
      
        {
         active == 'main' && jobsData.length !==0  && loadingTrue ===false  ?  <JobsTable jobsData={jobsData.reverse()}/> : null

        }
        {
          active =='company'  && jobsData.length !==0 && loadingTrue ===false  ?      <CompanyJobTable jobsData={jobsData.reverse()}/>: null 
     

        }
           {
            jobsData.length === 0 && loadingTrue ===false? 
            <Card className="mt-20">
                <CardBody>
                    <p className="text-center">No Lead Listed Yet <Link to={'/add-lead'} className="text-primary" style={{textDecoration:'underline'}}>Create New</Link></p>
                </CardBody>
            </Card> :null
        }

        </MasterLayout>
    </>
  )
}
